import { AxiosError } from "axios";
import Utilities from "../classes/Utilities";

declare var gtag;

class Analytics {
    static onPageRouteChanged(label: string, prevPath: string, currentPath: string) {
        gtag("event", "page_view", {
            event_label: label,
            page_path: currentPath
        });
    }

    static onScriptError(errorLabel: string, path:string, fileName: string, message: string, stack: string) {
        try {
            console.log("script error");
            gtag(
                "event",
                "error.script",
                {
                    "event_label": errorLabel,
                    "path": path,
                    "file_name": fileName,
                    "message": message,
                    "stack": stack,
                }
            );
        } catch (e) {
            console.log(e);
        }
    }

    static onAjaxError(label: string, error: AxiosError<any>, path?: string) {
        try {
            let parameters = {};

            parameters = {
                ...parameters,
                event_label: label,
                status: error.response?.status ?? "",
                statusText: error.response?.statusText ?? "",
                url: error.response?.config.url ?? "",
                method: error.response?.config.method ?? "",
            };

            if ("post" === (error.response?.config.method?.toLocaleLowerCase() ?? "")) {
                const data = error.response?.config.data ?? "";
                const dataStringified = Utilities.isObject(data)
                    ? JSON.stringify(data)
                    : data ? data.toString() : "";

                parameters = { ...parameters, data: dataStringified };
            }

            if (path) {
                parameters = { ...parameters, path };
            }

            gtag(
                "event",
                "error.ajax",
                parameters
            );
        } catch (e) {
            console.log(e);
        }
    }
}

export default Analytics;